import {
  CONFIRMED_GET_DISEASES,
  CONFIRMED_CREATE_DISEASE,
  CONFIRMED_DELETE_DISEASE,
  CONFIRMED_EDIT_DISEASE,
} from "./DiseasesTypes";

import {
  getDiseases,
  createDisease,
  updateDisease,
  deleteDisease,
  formatDiseases,
} from "../../services/DiseasesService";

import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Utility to get token
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

// Get Diseases
// export function getDiseasesAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
//   return async (dispatch, getState) => {
//     try {
//       const token = getAuthToken(getState);
//       const response = await getDiseases(pagination, pageid,search_by,search_keyword, sort_by, sort_order,token);

//       if (response?.status === 200 && response.data?.status === "success") {
//         const diseases = formatDiseases(response.data.data);
//         dispatch({ type: CONFIRMED_GET_DISEASES, payload: diseases });
//       } else {
//         handleError("Failed to get diseases: Server error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get diseases");
//     }
//   };
// }
export function getDiseasesAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const response = await getDiseases(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order,
        token
      );
      if (response?.status === 200 && response.data?.status === "success") {
        const diseases = formatDiseases(response.data.data);
        const num_rows = response.data.num_rows || 0;
        dispatch({
          type: CONFIRMED_GET_DISEASES,
          payload: { diseases, num_rows },
        });
      } else {
        handleError("Failed to get diseases: Server error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get diseases");
    }
  };
}

// Delete Disease
export function deleteDiseaseAction(diseaseId, history) {
  return async (dispatch) => {
    try {
      await deleteDisease(diseaseId);
      dispatch({
        type: CONFIRMED_DELETE_DISEASE,
        payload: { disease_id: diseaseId },
      });
      if (history) history.push("/diseases");
      handleSuccess("Disease deleted successfully!");
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete disease");
    }
  };
}

// Create Disease
export function createDiseaseAction(diseaseData, navigate) {
  return async (dispatch) => {
    try {
      const response = await createDisease(diseaseData);
      if (response?.status === 200 && response.data?.status === "success") {
        const formattedDisease = formatDiseases([response.data.data])[0];
        dispatch({ type: CONFIRMED_CREATE_DISEASE, payload: formattedDisease });
        if (navigate) navigate("/diseases");
        handleSuccess("Disease created successfully!");
      } else {
        showErrorAlert("Failed to create disease");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to create disease");
    }
  };
}

// Update Disease
export function updateDiseaseAction(diseaseData, diseaseId, navigate) {
  return async (dispatch) => {
    try {
      const payload = { ...diseaseData, disease_id: diseaseId };
      const response = await updateDisease(payload);
      if (response?.status === 200 && response.data?.status === "success") {
        const formattedDisease = formatDiseases([response.data.data])[0];
        dispatch({ type: CONFIRMED_EDIT_DISEASE, payload: formattedDisease });
        if (navigate) navigate("/diseases");
        handleSuccess("Disease updated successfully!");
      } else {
        showErrorAlert("Failed to update disease");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to update disease");
    }
  };
}
